const OPERATION_IDS = {
  sum: 1,
  average: 2,
}

export default {
  methods: {
    isGroupOperationSum(quality_group) {
      return quality_group.operator_id == OPERATION_IDS.sum;
    },
    isGroupOperationAverage(quality_group) {
      return quality_group.operator_id == OPERATION_IDS.average;
    },
    operateData: function (data, quality_group) {
      if (this.isGroupOperationSum(quality_group)) {
        data = data.map(value => Number(value))
        return data.reduce((acc, cur) => acc + cur, 0);
      } else if (this.isGroupOperationAverage(quality_group)) {
        return data.reduce((acc, cur) => acc + cur, 0) / data.length;
      }
      return 0;
    },
  },
}